import { Check, Minus } from 'lucide-react';
import { NumText } from '@/components/ui/num-text';
import type { FitStatus } from '@/lib/matchedDemand';

export interface FitStripCell { label: string; ask: string; have: string; status: FitStatus }

/** Side-by-side "what was asked vs what fits" strip shared by buyer and seller views. */
export default function FitStrip({ askLabel, haveLabel, cells }: { askLabel: string; haveLabel: string; cells: FitStripCell[] }) {
  return (
    <div className="grid grid-cols-[auto_repeat(3,minmax(0,1fr))] gap-x-4 rounded-md bg-muted/50 px-3 py-2">
      <div className="pt-[18px] text-xs text-muted-foreground leading-[1.35rem]">
        <p>{askLabel}</p><p>{haveLabel}</p>
      </div>
      {cells.map((c) => (
        <div key={c.label} className="min-w-0">
          <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{c.label}</p>
          <p className="mt-0.5 text-xs text-muted-foreground truncate"><NumText role="num-cell">{c.ask}</NumText></p>
          <p className={`mt-0.5 flex items-center gap-1 text-sm ${c.status === 'short' ? 'text-muted-foreground' : 'text-foreground font-medium'}`}>
            {c.status === 'meets' ? <Check className="h-3.5 w-3.5 shrink-0" aria-label="Fits" /> : c.status === 'short' ? <Minus className="h-3.5 w-3.5 shrink-0" aria-label="Short" /> : null}
            <NumText role="num-cell">{c.have}</NumText>
          </p>
        </div>
      ))}
    </div>
  );
}
